function copyShareUrl(url) {
  if (!url) return;

  if (navigator.clipboard?.writeText) {
    navigator.clipboard.writeText(url).catch(() => {});
    return;
  }

  const input = document.createElement('input');
  input.value = url;
  input.setAttribute('readonly', '');
  input.style.position = 'absolute';
  input.style.left = '-9999px';
  document.body.appendChild(input);
  input.select();
  document.execCommand('copy');
  document.body.removeChild(input);
}

document.addEventListener('click', async (event) => {
  const button = event.target.closest('[data-pdp-share]');
  if (!(button instanceof HTMLButtonElement)) return;

  const shareUrl = button.dataset.shareUrl || window.location.href;
  const shareTitle = button.dataset.shareTitle || document.title;

  if (navigator.share) {
    try {
      await navigator.share({ title: shareTitle, url: shareUrl });
      return;
    } catch (error) {
      if (error?.name === 'AbortError') return;
    }
  }

  copyShareUrl(shareUrl);
  button.dataset.justCopied = 'true';
  window.setTimeout(() => {
    delete button.dataset.justCopied;
  }, 1600);
});
